import { GET_MODULE_LIST, GET_MODULE_LIST_FAILURE, GET_MODULE_LIST_SUCCESS } from "../types";

export const getModuleList = (payload) => ({
    type: GET_MODULE_LIST,
    payload
})
export const getModuleListSuccess = (payload) => ({
    type: GET_MODULE_LIST_FAILURE,
    payload
})
export const getModuleListFailure = (payload) => ({
    type: GET_MODULE_LIST_SUCCESS,
    payload
})